import createModalRouteNavigation from "@src/components/general/ModalCheckoutRoute/createModalRouteNavigation";
import { useConfiguration } from "@src/hooks/query/useConfiguration";
import useNavigationUrlFactory from "@src/hooks/useNavigationUrlFactory";
import { useTranslation } from "@src/hooks/useTranslation";
import { useRollingStartNavigation } from "@src/lib/rolling-start-navigation";
import ShowMoreLink from "design-system/src/Navigation/ShowMoreLink/ShowMoreLink";
import FlexBox from "design-system/src/Components/FlexBox/FlexBox";
import Container from "design-system/src/Components/Grid/Container/Container";
import Typography from "design-system/src/Foundation/Typography/Typography";
import OrderAccordion from "design-system/src/Core/OrderAccordion/OrderAccordion";
import withDrawer, { IWithDrawerProps } from "design-system/src/HOC/withDrawer";
import React from "react";
import { useReorderContentLogic } from "./UseReorderContentLogic";

export interface IReorderContentProps extends IWithDrawerProps {}

const ReorderContent = (props: IReorderContentProps) => {
  const { onClose } = props;
  const { list } = useReorderContentLogic(props);
  const { t } = useTranslation(["Navigation", "Account", "UI"]);
  const { navigate } = useRollingStartNavigation();
  const { getConfiguration: c } = useConfiguration();
  const routes = useNavigationUrlFactory();
  const _ACCOUNT_ORDERS_REWRITE_ = c("_ACCOUNT_ORDERS_REWRITE_", "orders-history");
  const allOrderLink = routes.accountPage(_ACCOUNT_ORDERS_REWRITE_);

  return (
    <Container>
      <FlexBox
        direction="column"
        justify={"center"}
        style={{
          maxWidth: 485,
          margin: "0 auto",
          paddingTop: 5,
          paddingBottom: 36,
        }}
      >
        <FlexBox direction="column" justify={"center"}>
          <Typography variant="h5" color="placeholder" align="center" mb={31}>
            {t("Repasser une commande", "Navigation")}
          </Typography>

          <OrderAccordion
            list={list}
            reorderLabel={t("Recommander", "Account")}
            deleteLabel={t("Supprimer", "UI")}
          />

          <ShowMoreLink
            style={{ marginTop: "auto", paddingTop: 25 }}
            label={t("Voir toutes mes commandes", "Navigation")}
            href={allOrderLink}
            onClick={(e) => {
              e.preventDefault();
              navigate(allOrderLink);
              onClose && onClose();
            }}
          />
        </FlexBox>
      </FlexBox>
    </Container>
  );
};

ReorderContent.displayName = "ReorderContent";

export const ReorderContentDrawer = withDrawer<
  IReorderContentProps & IWithDrawerProps
>(ReorderContent, {
  closable: true,
  extraContent: createModalRouteNavigation(),
});

ReorderContentDrawer.displayName = "ReorderContentDrawer";

export default ReorderContent;
